export const Reports = () => {
  return <div>მალე დაემატება</div>;
};
